module.exports = __webpack_public_path__ + "img/home-banner.f01aa9d5.png";